export type TabListType = {
  prKey: string;
  prTypeId: string;
  codeOption: string;
  label: string;
  priceHT: number;
  priceTTC: number;
  checked: boolean;
  prFamily: string;
};

export const CarOptionsConfig = {
  itemsPerPage: 10,
};

// eslint-disable-no-shadow
export enum CarOptionTabs {
  SUMMARY = 'SUMMARY',
  Options = 'Options',
  Color = 'Color',
  Rim = 'Rim',
  Pack = 'Pack',
  Upholstery = 'Upholstery',
}

export enum CarOptionsPrFamilies {
  Options = '620',
  Color = '622',
  Rim = '1383',
  Pack = '1457',
  Upholstery = '623',
}
